import React, { forwardRef } from 'react';
import { css, cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { useDrawerContext } from '../context';

const contentStyle = css`
  flex: 1;
  overflow-y: auto;
`;

export const DrawerContent = forwardRef<HTMLDivElement, CommonHTMLAttributes & { children: React.ReactNode }>(
  ({ children, id, className, ...rest }, ref) => {
    const { descriptionId } = useDrawerContext();

    return (
      <div ref={ref} id={id ?? descriptionId} className={cx(contentStyle, className)} {...rest}>
        {children}
      </div>
    );
  }
);

DrawerContent.displayName = 'DrawerContent';
